module.exports = __webpack_public_path__ + "static/media/Product.c7aad6fa.jpg";